import { render, staticRenderFns } from "./ReptPerson.vue?vue&type=template&id=465f53fd&scoped=true&"
import script from "./ReptPerson.vue?vue&type=script&lang=js&"
export * from "./ReptPerson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465f53fd",
  null
  
)

export default component.exports